import * as React from 'react';

function SVGIconPushBack(props) {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 5.5V19.5H6V5.5H8ZM18.3432 6.91421L16.929 5.5L9.85789 12.571L16.929 19.6421L18.3432 18.2279L12.6863 12.571L18.3432 6.91421Z"
        fill="#242938"
      />
    </svg>
  );
}

export const IconPushBack = React.memo(SVGIconPushBack);
